import { Expression } from "./abstract.expression";

export abstract class UnaryExpression extends Expression 
{
    constructor() 
    {
        super();
    }

    toQuery(): string 
    {
        throw new Error("Method not implemented.");
    }
}
